<template>
  <v-card>
    <v-toolbar color="primary">
      <v-toolbar-title class="subheading white--text">
        ADICIONAR ÍTEM
      </v-toolbar-title>
    </v-toolbar>
    <v-card-title class="titulo">
      <span color="primary"
        >{{ page === 1 ? "Veiculos" : "Cobertura" }}
        <small class="error--text" v-if="fipeInvalida">
          Não foi possível validar o ítem novo. Verifique a presença de erros no
          preenchimento dos campos marcados.</small
        >
      </span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text flex>
      <v-form ref="formulario" grid-list-lg class="content">
        <v-layout column v-if="page === 1">
          <v-layout row wrap pb-3>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Placa"
                v-model="veiculo.placa"
                :rules="regras.notNull"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="Chassi"
                v-model="veiculo.chassi"
                :rules="regras.notNull"
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="FIPE"
                v-model="veiculo.fipe"
                :mask="'######-#'"
                :error="fipeInvalida"
                :disabled="!alterarValores"
                return-masked-value
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="Marca"
                v-model="veiculo.marca"
                required
                :error="fipeInvalida"
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md3>
              <v-text-field
                label="Modelo"
                v-model="veiculo.modelo"
                :maxlength="65"
                :counter="65"
                required
                :error="fipeInvalida"
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap py-3>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.tipoVeiculoList"
                v-model="veiculo.tipoVeiculo"
                label="Tipo de Veiculos"
                item-text="titulo"
                :item-value="(item) => item"
                required
                :error="fipeInvalida"
                :disabled="!alterarValores"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.catVeiculoList"
                v-model="veiculo.catVeiculo"
                label="Categoria do Veículo"
                placeholder="Selecione uma opção"
                item-text="titulo"
                :item-value="(item) => item"
                :rules="regras.notNull"
                required
                :disabled="!alterarValores"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Ano Fabricação"
                v-model="veiculo.anoFab"
                :rules="regras.notNull"
                required
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Ano Modelo"
                v-model="veiculo.anoMod"
                :error="fipeInvalida"
                required
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-select
                :items="campos.ufPernoiteList"
                v-model="veiculo.ufPernoite"
                item-text="titulo"
                :item-value="(item) => item"
                label="UF Pernoite"
                required
                :disabled="!alterarValores"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.usoDoVeiculoList"
                v-model="veiculo.usoDoVeiculo"
                label="Uso do Veículo"
                placeholder="Selecione uma opção"
                item-text="titulo"
                :item-value="(item) => item"
                :rules="regras.notNull"
                required
                :disabled="!alterarValores"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap py-3>
            <v-flex xs12 sm5 md4>
              <v-select
                :items="campos.propriedadeRegistroDoCrlvList"
                v-model="veiculo.propriedadeRegistroDoCrlv"
                label="Propriedade (Registro do CRLV)"
                placeholder="Selecione uma opção"
                item-text="titulo"
                :item-value="(item) => item"
                :rules="regras.notNull"
                required
                :disabled="!alterarValores"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                class="body-1"
                label="Proprietário"
                v-model="veiculo.proprietario"
                :rules="regras.notNull"
                required
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="CPF/CNPJ"
                v-model="veiculo.cpfCnpj"
                :mask="
                  veiculo.cpfCnpj !== null && veiculo.cpfCnpj.length > 11
                    ? 'NN.NNN.NNN/NNNN-##'
                    : '###.###.###-###'
                "
                :rules="regras.notNull"
                required
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-radio-group
                height="50px"
                v-model="veiculo.chassiRemarcado"
                row
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1">Chassi Remarcado</span>
                <v-layout>
                  <v-flex
                    d-inline-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="!alterarValores"
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap pt-3>
            <v-flex xs12 sm5 md1>
              <v-radio-group v-model="veiculo.zeroKm" class="my-0 pt-0">
                <span class="themeGrey--text body-1">Zero Km</span>
                <v-layout>
                  <v-flex
                    d-inline-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="!alterarValores"
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.diasGarantZeroKmList"
                label="Dias de Garantia Zero Km"
                placeholder="Selecione"
                v-model="veiculo.diasGarantZeroKm"
                item-text="titulo"
                :item-value="(item) => item"
                :disabled="!alterarValores"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm4 md2>
              <v-menu
                ref="menu"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textInicio"
                    label="Saída da Concessionária"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    required
                    :disabled="!alterarValores"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateInicio"
                  @change="onDateChange"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
        </v-layout>
        <v-layout column v-else-if="page === 2">
          <!-- Primeira linha -->
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.tipoDePropostaList"
                v-model="veiculo.tipoDeProposta"
                label="Tipo de Proposta"
                placeholder="Selecione"
                item-text="titulo"
                :item-value="(item) => item"
                required
                :disabled="!alterarValores && !!veiculoAnterior.tipoDeProposta"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.renovacaoSinistroOptions"
                v-model="veiculo.renovacaoComSinistro"
                label="Tipo de Renovação"
                placeholder="Selecione"
                item-text="titulo"
                :item-value="(item) => item"
                required
                :disabled="
                  !alterarValores && !!veiculoAnterior.renovacaoComSinistro
                "
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.ciaRenovacaoList"
                v-model="veiculo.ciaRenovacao"
                label="Companhia de Renovação"
                placeholder="Selecione uma opção"
                item-text="titulo"
                :item-value="(item) => item"
                required
                :disabled="!alterarValores && !!veiculoAnterior.ciaRenovacao"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                class="body-1"
                label="Código da Renovação"
                v-model="veiculo.codRenovacao"
                required
                :disabled="!alterarValores && !!veiculoAnterior.codRenovacao"
                :rules="regras.cdRenovacao"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
          <!-- Segunda linha -->
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.classeList"
                v-model="veiculo.classeBonus"
                label="Classe"
                placeholder="Selecione"
                item-text="titulo"
                :item-value="(item) => item"
                required
                :disabled="!alterarValores && !!veiculoAnterior.classeBonus"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                class="body-1"
                label="Número Apolice Anterior"
                v-model="veiculo.numeroApoliceAnterior"
                required
                :disabled="
                  !alterarValores && !!veiculoAnterior.numeroApoliceAnterior
                "
                type="number"
                mask="###############"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                class="body-1"
                label="Número Anterior"
                v-model="veiculo.numeroItemAnterior"
                required
                :disabled="
                  !alterarValores && !!veiculoAnterior.numeroItemAnterior
                "
                type="number"
                mask="######"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
          <!-- Terceira linha -->
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.tipoCoberturaList"
                v-model="veiculo.tipoCobertura"
                label="Tipo de Cobertura"
                placeholder="Selecione"
                item-text="titulo"
                :item-value="(item) => item"
                required
                :disabled="!alterarValores && !!veiculoAnterior.tipoCobertura"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="Danos Materiais"
                v-model="veiculo.danosMateriais"
                required
                :disabled="!alterarValores && !!veiculoAnterior.danosMateriais"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="Danos Corporais"
                v-model="veiculo.danosCorporais"
                required
                :disabled="!alterarValores && !!veiculoAnterior.danosMateriais"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex d-flex xs12 sm5 md2>
              <v-text-field
                label="Danos Morais"
                v-model="veiculo.danosMoraisEEsteticos"
                required
                :disabled="
                  !alterarValores && !!veiculoAnterior.danosMoraisEEsteticos
                "
              ></v-text-field>
              <v-tooltip left color="themeGrey" max-width="350px">
                <template v-slot:activator="{ on }">
                  <v-icon class="info--text" small v-on="on">help</v-icon>
                </template>
                <span>DANOS MORAIS E ESTÉTICOS</span>
              </v-tooltip>
            </v-flex>
            <v-flex d-flex xs12 sm5 md2>
              <v-text-field
                label="Danos Terc."
                v-model="
                  veiculo.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                "
                required
                :disabled="
                  !alterarValores &&
                  !!veiculoAnterior.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                "
                type="number"
              ></v-text-field>
              <v-tooltip left color="themeGrey" max-width="350px">
                <template v-slot:activator="{ on }">
                  <v-icon class="info--text" small v-on="on">help</v-icon>
                </template>
                <span>DANOS MATERIAIS/CORPORAIS A TERCEIROS </span>
              </v-tooltip>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <!-- Quarta linha -->
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="APP Morte"
                v-model="veiculo.appMorte"
                required
                :disabled="!alterarValores && !!veiculoAnterior.appMorte"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="APP Invalidez"
                v-model="veiculo.appInvalidez"
                required
                :disabled="!alterarValores && !!veiculoAnterior.appInvalidez"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex d-flex xs12 sm5 md2>
              <v-text-field
                label="DHMO"
                v-model="veiculo.despesasMedicasHospitalaresEOdontologicas"
                required
                :disabled="
                  !alterarValores &&
                  !!veiculoAnterior.despesasMedicasHospitalaresEOdontologicas
                "
                type="number"
              ></v-text-field>
              <v-tooltip left color="themeGrey" max-width="350px">
                <template v-slot:activator="{ on }">
                  <v-icon class="info--text" small v-on="on">help</v-icon>
                </template>
                <span>DESP. MÉDICAS, HOSPITALARES E ODONTOLÓGICAS</span>
              </v-tooltip>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
          <!-- Quinta linha -->
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.tipoDeFranquiaList"
                v-model="veiculo.tipoDeFranquia"
                label="Tipo de Franquia"
                placeholder="Selecione uma opção"
                item-text="titulo"
                :item-value="(item) => item"
                required
                :rules="veiculo.tipoCobertura.id === 1 || veiculo.tipoCobertura.id === 2 ? regras.notNull : []"
                :disabled="veiculo.tipoCobertura !=null && veiculo.tipoCobertura.id === 3 || !alterarValores && !!veiculoAnterior.tipoDeFranquia"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-radio-group
                v-model="veiculo.tipoDeContratacao"
                class="my-0 pt-0"
                :rules="veiculo.tipoCobertura.id === 1 || veiculo.tipoCobertura.id === 2 ? regras.radioNotNull : []"
              >
                <span class="themeGrey--text body-1">Tipo Contratação</span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in campos.tipoDeContratacaoList"
                    :key="item.titulo"

                    ><v-radio
                      :label="item.titulo"
                      :value="item"
                      :disabled="veiculo.tipoCobertura !=null && veiculo.tipoCobertura.id === 3 || !alterarValores && !!veiculoAnterior.tipoDeContratacao"
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                type="number"
                label="% Ajuste VMR / VD"
                v-model="veiculo.percAjusteVmrOuVd"
                required
                :rules="veiculo.tipoCobertura.id === 1 || veiculo.tipoCobertura.id === 2 ? regras.notNull : []"
                :disabled="veiculo.tipoCobertura !=null && veiculo.tipoCobertura.id === 3 || !alterarValores && !!veiculoAnterior.percAjusteVmrOuVd
                "
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="Vlr. FIPE"
                type="number"
                v-model="veiculo.vlrFipe"
                required
                :disabled="!alterarValores && !!veiculoAnterior.vlrFipe"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="VD Contratado"
                v-model="veiculo.vdContratado"
                type="number"
                required
                :rules="veiculo.tipoDeContratacao === 1 ? regras.notNull : []"
                :disabled="
                  veiculo.tipoCobertura !=null && veiculo.tipoCobertura.id === 3 ||
                  !alterarValores && !!veiculoAnterior.vdContratado"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <!-- Sexta linha -->
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.vlrFranquiaDanosMateriaisList"
                v-model="veiculo.vlrFranquiaDanosMateriais"
                label="Vlr. Franquia. Dm"
                placeholder="Selecione"
                item-text="titulo"
                item-value="titulo"
                required
                :disabled="false"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1 style="margin-left: 12px;">
              <v-radio-group v-model="veiculo.garantiaUnica" class="my-0 pt-0">
                <span class="themeGrey--text body-1">Garantia Única</span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                        !alterarValores && !!veiculoAnterior.garantiaUnica
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="Vlr. Garant. Única"
                v-model="veiculo.vlrGarantiaUnica"
                type="number"
                required
                :rules="veiculo.garantiaUnica === true ? regras.notNull : []"
                :disabled="veiculo.garantiaUnica === false ||
                  !alterarValores && !!veiculoAnterior.vlrGarantiaUnica
                "
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.vlrFranquiaGarantiaUnicaList"
                v-model="veiculo.vlrFranquiaGarantiaUnica"
                label="Vlr. Franquia. Gu"
                placeholder="Selecione"
                item-text="titulo"
                item-value="titulo"
                required
                :disabled="veiculo.garantiaUnica == false"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
          <!-- Sétima linha -->
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="
                  veiculo.danosMateriaisADirigentesSociosEmpregadosEPrepostos
                "
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Danos Mat. Dirigentes, etc
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span
                      >DANOS MATERIAIS: DIRIGENTES, SÓCIOS, EMPREG. E PREPOSTOS
                    </span>
                  </v-tooltip>
                </span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                        !alterarValores &&
                        !!veiculoAnterior.danosMateriaisADirigentesSociosEmpregadosEPrepostos
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Danos Mat. Dirigentes"
                v-model="veiculo.vlrDmDirigenteSociosEmpregadosPrepostos"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="
                  veiculo.danosCorporaisADirigentesSociosEmpregadosEPrepostos
                "
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Danos Corp. Dirigentes, etc
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span
                      >DANOS CORPORAIS: DIRIGENTES, SÓCIOS, EMPREG. E PREPOSTOS
                    </span>
                  </v-tooltip></span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                        !alterarValores &&
                        !!veiculoAnterior.danosCorporaisADirigentesSociosEmpregadosEPrepostos
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Danos Corp. Dirigentes, etc"
                v-model="veiculo.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="veiculo.extensaoDeCoberturaRcfAVeiculosRebocados"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Ext. RCF Veículos Rebocados
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>EXTENSÃO DE COBERTURA RCF A VEÍCULOS REBOCADOS </span>
                  </v-tooltip></span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                        !alterarValores &&
                        !!veiculoAnterior.extensaoDeCoberturaRcfAVeiculosRebocados
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Ext. RCF Veículos Rebocados"
                v-model="veiculo.vlrExtensaoDeCoberturaRcfAVeiculosRebocados"
                required
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="
                  veiculo.guDmDcADirigentesSociosEmpregadosEPrepostos
                "
                class="my-0 pt-0"
                :disabled="veiculo.garantiaUnica === false"
              >
                <span class="themeGrey--text body-1"
                  >GU DM/DC Dirigentes, etc
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span
                      >GU DM/DC: DIRIGENTES, SÓCIOS, EMPREG. E PREPOSTOS
                    </span>
                  </v-tooltip>
                </span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                        veiculo.garantiaUnica === false ||
                        !alterarValores &&
                        !!veiculoAnterior.guDmDcADirigentesSociosEmpregadosEPrepostos
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. GU DM/DC Dirigentes"
                v-model="veiculo.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos"
                required
                :disabled="veiculo.garantiaUnica === false || veiculo.guDmDcADirigentesSociosEmpregadosEPrepostos === false"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <!-- Oitava linha -->
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="veiculo.coberturaAdicionalCarroceria"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Adicional Carroceria
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>COBERTURA ADICIONAL: CARROCERIA </span>
                  </v-tooltip></span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                      veiculo.tipoCobertura != null && veiculo.tipoCobertura.id === 3 || !alterarValores &&
                        !!veiculoAnterior.coberturaAdicionalCarroceria
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.descrCarroceriaList"
                v-model="veiculo.descrCarroceria"
                label="Descrição da Carroceria"
                placeholder="Selecione"
                item-text="titulo"
                :item-value="(item) => item"
                required
                :rules="veiculo.coberturaAdicionalCarroceria === true ? regras.notNull : []"
                :disabled="veiculo.coberturaAdicionalCarroceria === false || !alterarValores && !!veiculoAnterior.descrCarroceria"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Carroceria"
                type="number"
                v-model="veiculo.vlrCarroceria"
                required
                :rules="veiculo.coberturaAdicionalCarroceria === true ? regras.notNull : []"
                :disabled="veiculo.coberturaAdicionalCarroceria === false || !alterarValores && !!veiculoAnterior.vlrCarroceria"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="veiculo.coberturaAdicionalDespesasExtras"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Adicional Desp. Extras
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>COBERTURA ADICIONAL: DESPESAS EXTRAS </span>
                  </v-tooltip>
                </span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="!alterarValores &&
                        !!veiculoAnterior.coberturaAdicionalDespesasExtras
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Desp. Extras"
                :value="despesasExtrasFixoFormatado"
                readonly
                disabled
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="veiculo.extCobAmericaDoSul"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Ext. Cob. América do Sul
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>EXTENSÃO DE COBERTURA AMÉRICA DO SUL</span>
                  </v-tooltip></span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                      veiculo.tipoCobertura != null && veiculo.tipoCobertura.id === 3 || !alterarValores &&
                        !!veiculoAnterior.extCobAmericaDoSul
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
          <!-- Nona linha -->
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="veiculo.coberturaAdicionalEquipamentos"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Adicional Equip.
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>COBERTURA ADICIONAL: EQUIPAMENTOS </span>
                  </v-tooltip></span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                      veiculo.tipoCobertura !=null && veiculo.tipoCobertura.id === 3 || !alterarValores &&
                        !!veiculoAnterior.coberturaAdicionalEquipamentos
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.descrEquipamentosList"
                v-model="veiculo.descrEquipamentos"
                label="Descrição do Equipamento"
                placeholder="Selecione uma opção"
                item-text="titulo"
                :item-value="(item) => item"
                required
                :rules="veiculo.coberturaAdicionalEquipamentos === true ? regras.notNull : []"
                :disabled="veiculo.coberturaAdicionalEquipamentos === false ||  !alterarValores && !!veiculoAnterior.descrEquipamentos"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1 style="margin-left: 5px;">
              <v-text-field
                label="Vlr. Equipamento"
                v-model="veiculo.vlrEquipamentos"
                type="number"
                required
                :rules="veiculo.coberturaAdicionalEquipamentos === true ? regras.notNull : []"
                :disabled="veiculo.coberturaAdicionalEquipamentos === false || !alterarValores && !!veiculoAnterior.vlrEquipamentos"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1 style="margin-left: 10px;">
              <v-select
                :items="campos.kmAssistenciaList"
                v-model="veiculo.kmAssistencia"
                label="Km de Assistência"
                placeholder="Selecione"
                item-text="titulo"
                :item-value="(item) => item"
                required
                :disabled="!alterarValores && !!veiculoAnterior.kmAssistencia"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="carroReservaOpcoes"
                v-model="veiculo.carroReserva"
                label="Carro Reserva"
                :placeholder="categoriaSemCarroReserva ? 'Não Aplicável' : 'Selecione uma opção'"
                item-text="titulo"
                :item-value="(item) => item"
                :required="!categoriaSemCarroReserva"
                :disabled="(!alterarValores && !!veiculoAnterior.carroReserva) || categoriaSemCarroReserva"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="coberturaVidrosOpcoes"
                v-model="veiculo.coberturaVidros"
                label="Cobertura Vidros"
                :placeholder="categoriaSemVidros ? 'Não Aplicável' : 'Selecione'"
                item-text="titulo"
                :item-value="(item) => item"
                :required="!categoriaSemVidros"
                :disabled="categoriaSemVidros"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
          <!-- Décima linha -->
          <v-layout wrap py-2>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-model="veiculo.coberturaAdicionalAcessorios"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Adicional Acessórios
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>COBERTURA ADICIONAL: ACESSÓRIOS </span>
                  </v-tooltip></span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                      veiculo.tipoCobertura !=null && veiculo.tipoCobertura.id === 3 || !alterarValores &&
                        !!veiculoAnterior.coberturaAdicionalAcessorios
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.descrAcessoriosList"
                v-model="veiculo.descrAcessorios"
                label="Descrição do Acessório"
                placeholder="Selecione uma opção"
                item-text="titulo"
                :item-value="(item) => item"
                required
                :rules="veiculo.coberturaAdicionalAcessorios === true ? regras.notNull : []"
                :disabled="veiculo.coberturaAdicionalAcessorios === false || !alterarValores && !!veiculoAnterior.descrAcessorios"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Acessório"
                type="number"
                v-model="veiculo.vlrAcessorios"
                required
                :rules="veiculo.coberturaAdicionalAcessorios === true ? regras.notNull : []"
                :disabled="veiculo.coberturaAdicionalAcessorios === false || !alterarValores && !!veiculoAnterior.vlrAcessorios"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Blindagem"
                type="number"
                v-model="veiculo.vlrBlindagem"
                required
                :disabled="!alterarValores && !!veiculoAnterior.vlrBlindagem"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Vlr. Kit Gás"
                type="number"
                v-model="veiculo.vlrKitGas"
                required
                :disabled="!alterarValores && !!veiculoAnterior.vlrKitGas"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
          <!-- Décima primeira linha -->
          <v-layout wrap py-2>
            <v-flex xs12 sm3 md2>
              <v-radio-group
                v-model="veiculo.caminhaoBasculado"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1">Caminhão Basculado</span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                        !alterarValores && !!veiculoAnterior.caminhaoBasculado
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm3 md1>
              <v-radio-group
                v-model="veiculo.vlrDeNovo180Dias"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Vlr. de Novo (180 dias)</span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                        !alterarValores && !!veiculoAnterior.vlrDeNovo180Dias
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md1>
              <v-radio-group
                v-model="veiculo.vlrDeNovo365Dias"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Vlr. de Novo (365 dias)</span
                >
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                        !alterarValores && !!veiculoAnterior.vlrDeNovo365Dias
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md2>
              <v-radio-group
                v-model="veiculo.garantiaCompreensivaParaTumultos"
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1"
                  >Compreensiva: Tumultos
                  <v-tooltip left color="themeGrey" max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon class="info--text" small v-on="on">help</v-icon>
                    </template>
                    <span>GARANTIA COMPREENSIVA PARA TUMULTOS</span>
                  </v-tooltip>
                </span>
                <v-layout>
                  <v-flex
                    d-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="
                        !alterarValores &&
                        !!veiculoAnterior.garantiaCompreensivaParaTumultos
                      "
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Fechar</v-btn>
    </v-snackbar>
    <v-card-actions class="pa-5">
      <v-spacer></v-spacer>
      <template v-if="page === 1">
        <v-btn color="primary" flat @click="fechar">Cancelar</v-btn>
        <v-btn class="button-custom" @click="revalidaCamposFipe" flat
          >Seguinte</v-btn
        >
      </template>
      <template v-if="page === 2">
        <v-btn color="primary" flat @click="page = 1">Voltar</v-btn>
        <v-btn
          class="button-custom"
          @click="adicionarItem() ? (page = 2) : null"
          flat
          >Adicionar</v-btn
        >
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import CustomFormat from "@/helpers/custom-format";
import { VMoney } from "v-money";
import mask from "@/helpers/mask";
import debounce from "@/helpers/debounce";
import despesasExtrasHelper from "@/helpers/despesas-extras";

const CAT_VEICULO_SEM_VIDROS = [6];
const CAT_VEICULO_SO_BASICO = [1, 2, 5];
const ID_VIDRO_COMPLETO = 2;
const CAT_VEICULO_SEM_CARRO_RESERVA = [1, 2, 5, 6];

export default {
  name: "AdicionarItemEndossoModal",
  directives: {
    money: VMoney,
  },
  data: () => {
    return {
      dateInicio: new Date().toISOString().slice(0, 10),
      page: 1,
      menu1: false,
      snack: false,
      snackColor: "",
      snackText: "",
      simOuNao: [
        {
          value: false,
          titulo: "Não",
        },
        {
          value: true,
          titulo: "Sim",
        },
      ],
      fipeInvalida: false,
      bloquearAutoCarga: false,
      regras: {
        notNull: [(v) => !!v || "Você não pode deixar este campo em branco"],
        radioNotNull: [(v) => !!v || "Selecione uma opção"],
        cnpj: [(v) => !!String(v).match(/^[A-Za-z0-9]{12}\d{2}$/) || "CNPJ incorreto"],
      },
      veiculo: {
        item: null,
        placa: null,
        chassi: null,
        fipe: null,
        marca: null,
        modelo: null,
        tipoVeiculo: {},
        catVeiculo: {},
        anoMod: null,
        anoFab: null,
        ufPernoite: null,
        usoDoVeiculo: null,
        propriedadeRegistroDoCrlv: null,
        proprietario: null,
        cpfCnpj: null,
        chassiRemarcado: false,
        zeroKm: false,
        diasGarantZeroKm: null,
        saidaDaConcessionaria: null,
        tipoCobertura: null,
        danosMateriais: null,
        danosCorporais: null,
        danosMoraisEEsteticos: null,
        danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado:
          null,
        appMorte: null,
        vlrDmDirigenteSociosEmpregadosPrepostos: 0,
        appInvalidez: null,
        despesasMedicasHospitalaresEOdontologicas: null,
        despesasExtras: null,
        garantiaUnica: false,
        vlrGarantiaUnica: 0.0,
        tipoDeContratacao: null,
        percAjusteVmrOuVd: "0",
        tipoDeFranquia: null,
        tipoDeProposta: null,
        renovacaoComSinistro: null,
        vlrFranquiaDanosMateriais: null,
        vlrFranquiaGarantiaUnica: null,
        classeBonus: null,
        numeroApoliceAnterior: null,
        numeroItemAnterior: null,
        ciaRenovacao: null,
        codRenovacao: null,
        caminhaoBasculado: false,
        vlrDeNovo180Dias: false,
        vlrDeNovo365Dias: false,
        garantiaCompreensivaParaTumultos: false,
        danosCorporaisADirigentesSociosEmpregadosEPrepostos: false,
        danosMateriaisADirigentesSociosEmpregadosEPrepostos: false,
        guDmDcADirigentesSociosEmpregadosEPrepostos: false,
        vlrGuDmDcADirigentesSociosEmpregadosEPrepostos: 0,
        extensaoDeCoberturaRcfAVeiculosRebocados: false,
        extCobAmericaDoSul: false,
        kmAssistencia: 0,
        carroReserva: null,
        vlrFipe: 0,
        vdContratado: 0,
        coberturaAdicionalCarroceria: false,
        coberturaAdicionalEquipamentos: false,
        coberturaAdicionalAcessorios: false,
        coberturaAdicionalDespesasExtras: false,
        descrCarroceria: null,
        vlrCarroceria: 0,
        descrEquipamentos: null,
        vlrEquipamentos: 0,
        descrAcessorios: null,
        vlrAcessorios: 0,
        vlrBlindagem: 0,
        vlrKitGas: 0,
        coberturaVidros: null,
        vlrExtensaoDeCoberturaRcfAVeiculosRebocados: 0,
        vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos: 0,
      },
      idApolice: null,
      veiculoAnterior: {},
      carregaVeiculoDebounced: () => {},
      despesasExtrasFixo: null,
    };
  },
  props: {
    dialog: Boolean,
    item: Number,
    campos: Object,
    alterarValores: Boolean,
    placa: { type: String, required: false },
    chassi: { type: String, required: false },
    modificacoes: { type: Object, required: false },
    numeroRevisao: Number,
    diferencaObjetos: { type: Boolean, required: false, default: false },
    edicaoSubstituto: { type: Boolean, required: false, default: false },
    chassis: Array,
  },
  computed: {
    textInicio() {
      return new Date(this.dateInicio).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    maskComputed: function () {
      return mask;
    },
    categoriaSemVidros() {
      const idCat = this.veiculo && this.veiculo.catVeiculo ? this.veiculo.catVeiculo.id : null;
      return idCat != null && CAT_VEICULO_SEM_VIDROS.includes(idCat);
    },
    coberturaVidrosOpcoes() {
      const idCat = this.veiculo && this.veiculo.catVeiculo ? this.veiculo.catVeiculo.id : null;
      const lista = (this.campos.coberturaVidrosList || []).filter((opt) => {

        if (opt.id == null || opt.id === 0) return false;
        if (idCat != null && CAT_VEICULO_SO_BASICO.includes(idCat)) {
          return opt.id !== ID_VIDRO_COMPLETO;
        }
        return true;
      });

      return [{ id: 0, titulo: "Nenhum" }, ...lista];
    },
    categoriaSemCarroReserva() {
      const idCat = this.veiculo && this.veiculo.catVeiculo ? this.veiculo.catVeiculo.id : null;
      return idCat != null && CAT_VEICULO_SEM_CARRO_RESERVA.indexOf(idCat) !== -1;
    },
    carroReservaOpcoes() {
      const lista = (this.campos.carroReservaList || []).filter(
        (opt) => opt && opt.id != null && opt.id !== 0
      );
      return [{ id: 0, titulo: "Nenhum" }, ...lista];
    },
    despesasExtrasFixoFormatado() {
      return this.despesasExtrasFixo === null
        ? ""
        : CustomFormat.toMoneyString(this.despesasExtrasFixo);
    },

  },

  watch: {
    dateInicio: function() {
      return this.veiculo.saidaDaConcessionaria = this.dateInicio
    },
    "veiculo.catVeiculo": function () {
      this.ajustarCarroReservaPorCategoria();
    },
    "veiculo.vlrDmDirigenteSociosEmpregadosPrepostos": function (val) {
      if(val != null) {
        return this.veiculo.vlrDmDirigenteSociosEmpregadosPrepostos === null || this.veiculo.vlrDmDirigenteSociosEmpregadosPrepostos === '' ?
       this.veiculo.vlrDmDirigenteSociosEmpregadosPrepostos = 0 : this.veiculo.vlrDmDirigenteSociosEmpregadosPrepostos
      }

    },
    "veiculo.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos": function (val) {
      if(val != null && val !== '') {
        return this.veiculo.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos
      }
    },
    "veiculo.vlrExtensaoDeCoberturaRcfAVeiculosRebocados": function (val) {
      if(val != null) {
        return this.veiculo.vlrExtensaoDeCoberturaRcfAVeiculosRebocados === null || this.veiculo.vlrExtensaoDeCoberturaRcfAVeiculosRebocados === '' ?
      this.veiculo.vlrExtensaoDeCoberturaRcfAVeiculosRebocados = 0 : this.veiculo.vlrExtensaoDeCoberturaRcfAVeiculosRebocados
      }

    },
    "veiculo.vlrCarroceria": function (val) {
      if(val != null) {
        return this.veiculo.vlrCarroceria === null || this.veiculo.vlrCarroceria === '' ?
       this.veiculo.vlrCarroceria = 0 : this.veiculo.vlrCarroceria
      }

    },
    "veiculo.danosCorporais": function (val) {
      if(val != null) {
        let valor = this.veiculo.danosCorporais === null || this.veiculo.danosCorporais === ''
        ? this.veiculo.danosCorporais = 0 : this.veiculo.danosCorporais;
        if(this.veiculo.rcfExtCobAmericaDoSul)  {
          this.veiculo.vlrRcfExtCobAmericaDoSul = Number(this.veiculo.danosMateriais) +
          Number(valor) + Number(this.veiculo.vlrGarantiaUnica)
        }
        return valor
      }

    },
    "veiculo.danosMateriais": function (val) {
      if(val != null) {
        let valor = this.veiculo.danosMateriais === null || this.veiculo.danosMateriais === ''
        ? this.veiculo.danosMateriais = 0 : this.veiculo.danosMateriais;

        if(this.veiculo.rcfExtCobAmericaDoSul)  {
          this.veiculo.vlrRcfExtCobAmericaDoSul = Number(valor) +
          Number(this.veiculo.danosCorporais) + Number(this.veiculo.vlrGarantiaUnica)
        }
        return valor
      }

    },
    "veiculo.danosMoraisEEsteticos": function (val) {
      if(val != null) {
        return this.veiculo.danosMoraisEEsteticos === null || this.veiculo.danosMoraisEEsteticos === ''
     ? this.veiculo.danosMoraisEEsteticos = 0 : this.veiculo.danosMoraisEEsteticos
      }

    },
    "veiculo.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado" : function (val) {
      if(val != null) {
        return this.veiculo.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado === null
      || this.veiculo.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado === '' ?
      this.veiculo.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado = 0 :
       this.veiculo.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
      }

    },
    "veiculo.vlrEquipamentos" : function (val) {

      if(val != null) {
        return this.veiculo.vlrEquipamentos === null || this.veiculo.vlrEquipamentos === '' ?
       this.veiculo.vlrEquipamentos = 0 : this.veiculo.vlrEquipamentos
      }

    },
    "veiculo.vlrAcessorios" : function (val) {
      if(val != null) {
        return this.veiculo.vlrAcessorios === null || this.veiculo.vlrAcessorios === '' ?
      this.veiculo.vlrAcessorios = 0 : this.veiculo.vlrAcessorios
      }

    },
    "veiculo.placa":  function(val) {
      if (this.bloquearAutoCarga) {
        return;
      }
      if(val != null && this.veiculo.chassi.length > 6 && this.veiculo.placa != this.placa ) {
        this.carregaVeiculo(val, null);

      }
    },
    "veiculo.chassi": function (val) {
      if (this.bloquearAutoCarga) {
        return;
      }
      if(val != null && this.veiculo.chassi.length > 16 && this.veiculo.chassi != this.chassi) {
        this.carregaVeiculo(null,val);

      }
    },
    "veiculo.tipoCobertura": function (val) {
      if(val != null ) {
        this.carregaCamposCasoTipoCoberturaRCF(val);

      }
    },
    "veiculo.tipoDeContratacao": function (val) {
      if(val != null) {
        this.carregarTipoContratacao(val)

      }
    },
    "veiculo.garantiaUnica": function (val) {
      if(val != null) {
        this.carregarGarantiaUnica(val)
      }
    },
    "veiculo.descrCarroceria":function (val) {
      if(val != null) {
        this.carregarDescricaoCarroceria(val)

      }
    },
    "veiculo.descrEquipamentos":function (val) {
      if(val != null) {
        this.carregarDescricaoEquipamentos(val)

      }
    },
     "veiculo.descrAcessorios":function (val) {
      if(val != null) {
        this.carregarDescricaoAcessorio(val)

      }
    },
    "veiculo.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos": function (val) {
      if(val != null) {
        this.veiculo.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos == null ||
      this.veiculo.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos == "" ?
      this.veiculo.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos = 0 :
      this.veiculo.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
      }

    },
    "veiculo.guDmDcADirigentesSociosEmpregadosEPrepostos": function (val) {
      if (!val) {
        this.veiculo.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos = null;
      }
    },
    "veiculo.rcfExtCobAmericaDoSul": function (val) {
      if(!val) {
        this.veiculo.vlrRcfExtCobAmericaDoSul = 0;
      } else {
        this.veiculo.rcfExtCobAmericaDoSul  = this.veiculo.rcfExtCobAmericaDoSul == null ? false : this.veiculo.rcfExtCobAmericaDoSul;
        if(this.veiculo.rcfExtCobAmericaDoSul)  {
          this.veiculo.vlrRcfExtCobAmericaDoSul = Number(this.veiculo.danosMateriais) +
          Number(this.veiculo.danosCorporais) + Number(this.veiculo.vlrGarantiaUnica)
        }
      }
    },
    "veiculo.vlrGarantiaUnica": function (val) {

      if( this.veiculo.rcfExtCobAmericaDoSul && val)  {
        this.veiculo.vlrRcfExtCobAmericaDoSul = Number(this.veiculo.danosMateriais) +
        Number(val) + Number(this.veiculo.vlrGarantiaUnica)
      }
    },
    "veiculo.catVeiculo": {
      handler() {
        this.ajustarVidrosPorCategoria();
      },
    },


  },
  mounted() {
    this.idApolice = this.$route.query.id;
    this.bloquearAutoCarga = this.edicaoSubstituto;
    if(this.chassi){
      this.veiculo.chassi = this.chassi;
    }

    if (this.placa) {
      this.veiculo.placa = this.placa;
    }

    if(this.item) {
      this.veiculo.item = this.item;
    }
    this.carregarVeiculoDaGrid(this.placa, this.chassi);


  },
  created() {
    despesasExtrasHelper.buscarValorFixo().then(valor => {
      this.despesasExtrasFixo = valor;
    });
  },
  methods: {
    ajustarVidrosPorCategoria() {
      if (this.categoriaSemVidros) {
        this.veiculo.coberturaVidros = null;
        return;
      }
      const anterior =
        this.edicaoSubstituto && this.modificacoes && this.modificacoes.coberturaVidros
          ? this.modificacoes.coberturaVidros
          : this.veiculoAnterior
          ? this.veiculoAnterior.coberturaVidros
          : null;
      const idAnterior = anterior ? anterior.id : null;
      const disponivel = this.coberturaVidrosOpcoes.find((opt) => opt.id === idAnterior);
      this.veiculo.coberturaVidros = disponivel && disponivel.id != null ? disponivel : null;
    },
    ajustarCarroReservaPorCategoria() {
      if (this.categoriaSemCarroReserva) {
        this.veiculo.carroReserva = null;
      }
    },
    onDateChange: function() {
      this.dateInicio = this.corretor.dataVencimentoApolice;
    },
    carregarDescricaoAcessorio(val){
      if(val.id === 0){
        this.veiculo.vlrAcessorios = null
      }
    },
    carregarDescricaoCarroceria(val){
      if(val.id === 0){
        this.veiculo.vlrCarroceria = null
      }
    },
    carregarDescricaoEquipamentos(val){
      if(val.id === 0){
        this.veiculo.vlrEquipamentos = null
      }
    },
    carregarGarantiaUnica(val){
      if(val === false){
        this.veiculo.vlrGarantiaUnica = null
        this.veiculo.guDmDcADirigentesSociosEmpregadosEPrepostos = false
        this.veiculo.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos = null
      }
    },
    carregarTipoContratacao(val){
      if(val === 0){
        this.veiculo.percAjusteVmrOuVd = null
      }
    },
    carregaCamposCasoTipoCoberturaRCF(val){
      if(val.id === 3){
        this.veiculo.tipoDeContratacao = null
        this.veiculo.percAjusteVmrOuVd = null
        this.veiculo.tipoDeFranquia = null
        this.veiculo.descrCarroceria = null
        this.veiculo.coberturaAdicionalCarroceria = false
        this.veiculo.coberturaAdicionalEquipamentos = false
        this.veiculo.coberturaAdicionalAcessorios = false
        this.veiculo.extCobAmericaDoSul = false
        this.veiculo.vlrCarroceria = 0
        this.veiculo.descrEquipamentos = null
        this.veiculo.vlrEquipamentos = 0
        this.veiculo.descrAcessorios = null
        this.veiculo.vlrAcessorios = 0
      }
    },

    async revalidaCamposFipe() {
      if (!this.$refs.formulario.validate()) {
        return;
      }

      let chassiRepetido = this.chassis.includes(this.veiculo.chassi) ? this.veiculo.chassi : null;

      let chassisFiltrados = this.chassis.filter(chassi => chassi != this.chassi);

      if (chassisFiltrados.includes(this.veiculo.chassi)) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `Erro no chassi: ${chassiRepetido}. Já possui um item com este chassi na apólice ou endosso.`;
        return;
      }

      const data = await axios
        .post(
          `${process.env.URL_PLANILHAMS}/v1/revalidarCamposPlanilha/`,
          [this.veiculo],
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => response.data)
        .catch(() => null);

      if (
        !(this.fipeInvalida = !(
          data instanceof Array &&
          data.length &&
          data[0].erro === false
        ))
      )
        this.page = 2;
    },

    carregaVeiculo(conteudoPlaca, conteudoChassi) {
      if ((conteudoPlaca && conteudoPlaca.length === 7) ||
          (conteudoChassi && conteudoChassi.length === 17 || conteudoChassi && conteudoChassi.length === 18)) {
        axios
          .get(
            `${process.env.URL_APOLICEMS}/v1/buscaVeiculo?idApolice=${this.idApolice}&placa=${conteudoPlaca}&chassi=${conteudoChassi}&item=${this.veiculo.item}&chassiAnterior=${this.veiculoAnterior.chassi}&placaAnterior=${this.veiculoAnterior.placa}`,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
              },
            }
          )
          .then((response) => {
            if (response.data) {
              Object.keys(this.veiculo).forEach((key) => {
                this.veiculo[key] =
                  this.modificacoes && this.modificacoes[key]
                    ? this.modificacoes[key]
                    : response.data[key];
              });

            }
          });
      }
    },
    carregarVeiculoDaGrid(conteudoPlaca, conteudoChassi) {
      if ((conteudoPlaca && conteudoPlaca.length === 7) ||
          (conteudoChassi && conteudoChassi.length === 17)) {
        axios
          .get(
            `${process.env.URL_APOLICEMS}/v1/buscaVeiculo?idApolice=${this.idApolice}&placa=${conteudoPlaca}&chassi=${conteudoChassi}&item=${this.veiculo.item}`,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
              },
            }
          )
          .then((response) => {
            if (response.data) {
              if (response.data.percAjusteVmrOuVd === null) {
                response.data.percAjusteVmrOuVd = "0"
              }
              Object.keys(this.veiculo).forEach((key) => {
                this.veiculoAnterior[key] = response.data[key];
                this.veiculo[key] = this.veiculoAnterior[key];
              });
              this.aplicarDadosSubstituto();
              this.ajustarVidrosPorCategoria();
              this.ajustarCarroReservaPorCategoria();
            }
          })
          .finally(() => {
            this.liberarAutoCarga();
          });
        } else {
          this.liberarAutoCarga();
        }
    },

    aplicarDadosSubstituto() {
      if (!this.edicaoSubstituto || !this.modificacoes) {
        return;
      }
      Object.keys(this.veiculo).forEach((key) => {
        if (this.modificacoes[key] !== undefined) {
          this.veiculo[key] = this.modificacoes[key];
        }
      });
    },

    liberarAutoCarga() {
      if (!this.bloquearAutoCarga) {
        return;
      }
      this.$nextTick(() => {
        this.bloquearAutoCarga = false;
      });
    },
    retornarModificacoes() {

        const modificado = Object.entries(this.veiculo).reduce(
          (acc, [key, value]) =>
            value !== this.veiculoAnterior[key] && value !== ""
              ? { ...acc, [key]: value }
              : acc,
          {}
        );
        if (modificado && Object.keys(modificado).length) {
          return JSON.parse(JSON.stringify({
            ...modificado,
            item: this.veiculoAnterior.item || this.veiculo.item,
          }));
        }

    },

    adicionarItem() {
      if (!this.$refs.formulario.validate()) {
        return;
      }
      this.$emit("add", this.retornarModificacoes());
    },
    fechar() {
      this.$emit("fechar");
    },
  },
};
</script>

<style>
.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}

@media (min-width: 1440px) {
  .titulo {
    padding-left: 1rem;
  }
  .content {
    max-width: 1600px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/AdicionarItemEndossoModal.vue